import { useQuery } from '@apollo/client'
import {
  getTreatmentSchema,
  getTreatmentSchemaVariables,
} from '../../../../models/graphqlTypes'
import { QueryHookOptions } from '@apollo/client/react/types/types'
import { GET_TREATMENT_SCHEMA } from '../operations/treatmentSchemaOperations'
import { TreatmentSchemaById } from '../types/treatmentSchemas.types'

type Options = QueryHookOptions<getTreatmentSchema, getTreatmentSchemaVariables>

type Return = {
  treatmentSchema?: TreatmentSchemaById
  loading: boolean
  refetch: () => void
}

export const useTreatmentSchemaData = (options?: Options): Return => {
  const {
    data: { getTreatmentSchema: treatmentSchema } = {},
    loading,
    refetch,
  } = useQuery<getTreatmentSchema, getTreatmentSchemaVariables>(
    GET_TREATMENT_SCHEMA,
    options
  )

  return {
    loading,
    treatmentSchema,
    refetch,
  }
}
